import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_autocomplete = _resolveComponent("autocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("label", null, "Cerca indirizzo", -1)),
    _createVNode(_component_autocomplete, {
      modelValue: _ctx.selectedPrediction,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPrediction) = $event)),
        _ctx.onPredictionSelected
      ],
      fetchFn: _ctx.fetchPredictions,
      labelFn: (item) => item.description
    }, {
      item: _withCtx(({ item, highlight }) => [
        _createElementVNode("span", {
          innerHTML: highlight(item.description)
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["modelValue", "fetchFn", "labelFn", "onUpdate:modelValue"])
  ]))
}